import script from "./CUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./CUpload.vue?vue&type=script&setup=true&lang=ts"

import "./CUpload.vue?vue&type=style&index=0&id=e1be1404&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1be1404"]])

export default __exports__